// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-jsx" + "-" + "ba653c5b76efa7e8e861" + ".js";
};